import * as RadixPopover from "@radix-ui/react-popover";
import { type ReactNode } from "react";
import styled from "@emotion/styled";
import { kfContentIn } from "@/lib/emotionTw";
import { BfrsPortalScope } from "@/components/ui/providers/BfrsProvider";
import { floatingCollisionPadding } from "../overlayPositioning";

export type PopoverProps = {
  trigger: ReactNode;
  children: ReactNode;
  align?: "start" | "center" | "end";
  className?: string;
};

/* Exact compiled output of the pre-migration Tailwind utilities, in the same
 * class-list emission order (floating layer, content utilities, collision
 * classes). Verified against the frozen baseline. */

const PopoverContent = styled(RadixPopover.Content, {
  label: "AgenticPopover-content"
})({
  zIndex: 1000,
  width: "20rem",
  borderRadius: "var(--bfrs-radius-xl)",
  borderWidth: "1px",
  "--tw-border-opacity": "1",
  borderColor: "hsl(var(--bfrs-color-border) / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  backgroundColor: "hsl(var(--bfrs-color-surface-card) / var(--tw-bg-opacity, 1))",
  padding: "1rem",
  "--tw-shadow": "var(--bfrs-shadow-elevated)",
  "--tw-shadow-colored": "var(--bfrs-shadow-elevated)",
  boxShadow: "var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)",
  outline: "2px solid transparent",
  outlineOffset: "2px",
  ...kfContentIn,
  animation: "bfrs-bfrs-content-in var(--bfrs-motion-normal) var(--bfrs-ease-out)",
  maxHeight: "min(32rem,var(--radix-popover-content-available-height))",
  maxWidth: "calc(100vw - 1rem)",
  overflow: "auto"
});

const PopoverArrow = styled(RadixPopover.Arrow, {
  label: "AgenticPopover-arrow"
})({
  fill: "hsl(var(--bfrs-color-surface-card) / 1)"
});

export function Popover({ trigger, children, align = "center", className }: PopoverProps) {
  return (
    <RadixPopover.Root>
      <RadixPopover.Trigger asChild>{trigger}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <BfrsPortalScope>
          <PopoverContent align={align} sideOffset={8} collisionPadding={floatingCollisionPadding} className={className}>
            {children}
            <PopoverArrow />
          </PopoverContent>
        </BfrsPortalScope>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  );
}
